import {ApolloLink} from '@apollo/client';
import type {IMetrics, IReports} from '@sail/observability';
import createHttpHeadersLink from './links/createHttpHeadersLink';
import createTerminatingLink from '../shared/graphql/links/createTerminatingLink';
import createV2LtmTelemetryLink from '../shared/graphql/links/createV2LtmTelemetryLink';
import createExtensionsLink from './links/createExtensionsLink';
import createHttpLinkWrapper from './links/createHttpLinkWrapper';

export type ObservabilityFns = {
  metrics: IMetrics;
  reports: IReports;
};

export default function createV2ApolloLink(endpoint: string) {
  return ApolloLink.from([
    createV2LtmTelemetryLink(),
    createExtensionsLink(),
    createHttpHeadersLink(endpoint),
    createTerminatingLink(createHttpLinkWrapper, endpoint),
  ]);
}
